
GP.GPMod('Chat.Util', function(self) {
    var _conf, _data, _gui, _apis, _vchat, _events,
        _info, _log, _warn, _error, _timers, _vent, _cometD;

    this.on('before:start', function() {
        var chat_module  = self.app.module("Chat");
        chat_module.util = _util;
    });

    self.init_module = function() {
        var chat_module   = self.app.module("Chat");

        _conf   = chat_module.conf;
        _data   = chat_module.data;
        _apis   = chat_module.apis;
        _gui    = chat_module.gui;
        _events = chat_module.events;
        _vchat  = chat_module.vchat;

        _vent  = self.vent;
        _info  = self.app.Util.info;
        _log   = self.app.Util.log;
        _warn  = self.app.Util.warn;
        _error = self.app.Util.error;
        _trace = self.app.Util.trace;

        _cometD = $.cometd;
        _timers = GP.Util.timers;
    };


    var _util = {
        is_mobile: function() {
            return (MoshPit.get_size() === 'mobile' || _is_mobile) ? true : false;
        },
        need_profile_redirect: function() {
            if (_current_module_page != 'user:profile') {
                return true;
            } else if (_current_module_page == 'user:profile' && self_profile_view === false) {
                return true;
            }
            return false;
        },
        chk_go_live_param: function() {
            var regex = /go_live=true/i;
            return regex.test(window.location.href);
        },
        chk_chat_vchat: function(check_chat_only) {
            if (typeof _current_module_page != 'undefined' && _current_module_page) {
                if (_current_module_page == 'chat:home') {
                    return true;
                }
                if (!check_chat_only && _data.vc.room_id) {
                    return true;
                }
            }
            return false;
        },
        is_vchat: function() {
            if (typeof _current_module_page != 'undefined' && _current_module_page) {
                if (_current_module_page == 'user:profile') {
                    return true;
                }
            }
            return false;
        },
        current_room_id: function() {
            var cr = _data.current_room;
            if (cr && cr.room_id) {
                return parseInt(cr.room_id, 10) || 0;
            }
            return 0;
        },
        reset_chat: function() {
            if (++_data.reload_tries <= _conf.max_reload_tries) {
                _log('RESETTING CHAT! count: ', _data.reload_tries);
                _events.leave_room();
                _events.clear_subscriptions();
                _data.reset_chat_data();
                _gui.reset();
                _events.init_chat();
            } else {
                _util.confirm_refresh();
            }
        },
        // parse chat room message for specially formatted gp_pic_url::PIC_URL message and return url if found
        parse_message_for_image: function(message) {
            if (typeof message != 'undefined' && message) {
                if (message.indexOf('gp_pic_url::') > -1) {
                    var tmp = message.split('::');
                    return tmp[1];
                }
            }
            return false;
        },
        parse_message_for_tip: function(message) {
            if (typeof message != 'undefined' && message) {
                if (message.indexOf('gp_tip_msg::') > -1) {
                    var tmp = message.split('::');
                    return tmp[1];
                }
            }
            return false;
        },
        parse_message_for_priv_deny: function(message) {
            if (typeof message != 'undefined' && message) {
                if (message.indexOf('gp_priv_deny::') > -1) {
                    var tmp = message.split('::');
                    return tmp[1];
                }
            }
            return false;
        },
        status_check: function() {
            _info('status_check CALLED');
            // clear timer if this timer is still running for some reason,
            // and we aren't on chat page or streaming
            if (!_util.chk_chat_vchat()) {
                _info('chat.util status_check not on chat, clearing timers');
                _util.clear_room_timers();
            } else if (_util.current_room_id() > 0) {
                if (!self.app.Cometd.check_connection()) {
                    _util.confirm_refresh();
                }

                var data_copy = jQuery.extend(true, {}, _data);
                _info('copy of _data: ', data_copy);
                if (_data.users.length > 0) {
                    var my_model = _data.users.get(_data.duid);
                    _info('my_model: ', my_model);

                    if (!_data.initial_user_set) {
                        _info("RE-JOINING ROOM");
                        _info("calling _util.reset_chat()...");

                        _util.reset_chat();
                    } else if (!my_model) {
                        _info("RE-INITIALIZING CHAT DUE TO USER NOT FOUND IN USER LIST");
                        _info("calling _util.reset_chat()...");

                        _util.reset_chat();
                    } else {
                        _info('FOUND MY USER, NO NEED TO RESET');
                    }
                } else {
                    _info("RE-INITIALIZING CHAT DUE TO USER LIST BEING EMPTY");
                    _info("calling _util.reset_chat()...");

                    _util.reset_chat();
                }
            }
        },
        confirm_refresh: function() {
            if (confirm(js_lang.chat.refresh)) {
                document.location.reload(true);
            } else {
                _timers.clear(_conf.timer_sc);
            }
        },
        log_error: function(error) {
            if (_data.errors_logged++ > 0) {
                return;
            }

            // // only send error to sentry if we haven't sent one today
            // if (!$.cookie(_conf.error_cookie)) {
            var cometd_status, transport, transport_type;

            // GP.Util.set_cookie(_conf.error_cookie, 1, _conf.error_cookie_exp);
            if (_cometD) {
                cometd_status  = _cometD.getStatus();
                transport      = _cometD.getTransport();
                transport_type = (transport && typeof transport.getType == 'function') ? transport.getType() : null;
            }

            var extra_chat_data = {
                extra: {
                    my_user:      GP.sdata.my_user,
                    current_room: _data.current_room,
                    cometd:       cometd_status + '/' + transport_type
                }
            };

            if (typeof Sentry != 'undefined') {
                if (error instanceof Error || (error && error.stack && error.message)) {
                    Sentry.captureException(error, extra_chat_data);
                } else {
                    Sentry.captureException(new Error(error), extra_chat_data);
                }
            }
        },
        // setup lazy loading of thumbnails (in a container for web and normal page scroll for mobile)
        lazyload: function() {
            if (_util.is_mobile()) {
                $("img.lazy").lazyload().removeClass("lazy");
            } else {
                $("img.lazy").lazyload({
                    effect : "fadeIn",
                    container: $("#user-list")
                }).removeClass("lazy");
            }
        },
        get_user: function(user) {
            if (typeof user != 'undefined' && user) {

                return {
                    duid:               parseInt(user.duid, 10),
                    username:           user.username,
                    gender:             user.gender,
                    age:                parseInt(user.age, 10),
                    location:           user.location,
                    pic_url:            user.pic_url,
                    thumb_url:          _util.get_pic_url(user),
                    profile_url:        _util.get_profile_url(user.duid),
                    profile_new_window: !_data.free_user,
                    label:              _util.get_user_label(user),
                    report_url:         _util.get_report_url(user),
                    show_report_url:    typeof GP.sdata.my_user.duid != 'undefined' && GP.sdata.my_user.duid != user.duid,
                    show_kick_user:     _data.vc.is_publisher && GP.sdata.my_user.duid != user.duid,
                };
            }
        },
        get_profile_url: function(profile_duid) {
            if (typeof profile_duid == 'undefined' || !profile_duid) {
                return '#';
            }
            return GP.Util.clean_url('members/user/profile', {duid: profile_duid});
        },
        get_pic_url: function(user) {
            if (typeof user != 'undefined' && user) {
                // show your own thumbnail or users who's gender match a gender in seeking
                if (user.duid == _data.duid || $.inArray(user.gender, _data.seeking) > -1) {
                    return user.pic_url;
                }
            }
            return '';
        },
        get_user_label: function(user) {
            if (typeof user != 'undefined' && user) {
                return user.username + ' / ' + user.age + ' / ' + user.location;
            }
            return '';
        },
        get_report_url: function(user) {
            if (typeof user != 'undefined' && user) {
                var report_data = {};
                report_data.reported_duid = user.duid;
                if (_util.is_vchat()) {
                    report_data.reported_from = 'vchat';
                    report_data.vchat_owner_duid = _data.vc.room_id;
                } else {
                    report_data.reported_from = 'group_chat';
                }
                return GP.Util.clean_url('/members/user/report_user/', report_data);
            }
            return '';
        },
        // wrapper to use main Util's is_user_blocked() function
        check_blocked_user: function(check_duid) {
            return GP.Util.is_user_blocked(check_duid, _data.blocked_users);
        },
        truncate: function(str) {
            var len = _conf.vc_goal_char_limit;
            return (str.length > len) ? str.substr(0,len-1)+'&hellip;' : str;
        },
        number_with_commas: function(x) {
            return (x || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        start_room_timers: function() {
            if (_util.current_room_id() > 0) {
                // _timers.set(_util.status_check, 10000, _conf.timer_sc, true);
                _timers.set(_util.update_expire, _conf.timer_interval, _conf.timer_ue, true);
            }
        },
        start_videochat_publisher_timer: function() {
            _log('util.start_videochat_publisher_timer called');
            _timers.clear(_conf.timer_cps);
            _timers.set(_util.check_publisher_stream, 10000, _conf.timer_cps, true);
        },
        clear_room_timers: function() {
            _timers.clear(_conf.timer_sc);
            _timers.clear(_conf.timer_ue);
            _timers.clear(_conf.timer_cps);
            _timers.clear(_conf.timer_vr);
            _vchat.reset_reconnect_timers(true);

            _timers.clear(_conf.timer_check_stream);
        },
        update_expire: function() {
            var id = _util.current_room_id();
            _cometD.publish(_conf.channel.update_expire, {room_id: id});
        },
        check_publisher_stream: function() {
            if (_data.vc.is_publisher) {
                if (_vchat.is_publisher_active() === false) {
                    _log('util.check_publisher_stream got FALSE from _vchat.is_publisher_active... ABORTING!!!');
                    _vchat.abort();
                }
            }
        },
        build_ticket_modal_url: function() {
            var cost = parseInt(_data.vc.ticket_info.credit_cost, 10),
                my_credits = parseInt(GP.sdata.my_user.credits, 10),
                purchase_credits = (cost > my_credits ? 1 : 0),
                streamer_duid = _data.vc.room_id,
                streamer_username = _data.vc.username;

            var params = {
                purchase_credits: purchase_credits,
                credit_cost: cost,
                streamer_duid: streamer_duid
            };

            var clean_url =  GP.Util.clean_url('/members/videochat/purchase_ticket_modal/', params);

            return clean_url;
        },

        start_ticket_show_timers: function() {
            // recurring and call immediately
            _timers.set(_gui.ticket_start_countdown, 1000, _conf.timer_ticket_info_timer, true, true);
        },
        clear_ticket_show_timers: function() {
            _timers.clear(_conf.timer_ticket_info_timer);
        },
        parse_private_url: function(url) {
            if (url) {
                var private_token,
                    player_url,
                    token_tmp = url.split('?')[1];

                // private_token = decodeURIComponent(token_tmp.split('=')[1]);
                private_token = token_tmp.split('=')[1];

                player_url = url.split('?')[0];

                return [player_url, private_token];
            }
        }
    };

});

